import { Col, Row, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Checkbox } from 'components/atoms/checkbox';
import { NotificationsByGroup } from './constants';
import { NotificationCollapse } from './notification-collapse';
import { Container } from './notification-group.styles';
import {
  NotificationActionTypes,
  NotificationGroupTypes,
} from './notification-group.types';

const { Text } = Typography;

const StyledCol = styled(Col)`
  margin-top: var(--spacing-01);
`;

export const NotificationGroup = ({
  type,
  label,
  icon,
  notifications = [],
  onNotificationChange,
  timeConfigurable: dateConfigurable,
}: NotificationGroupTypes & NotificationActionTypes) => {
  const filteredNotifications = useMemo(
    () =>
      notifications
        .filter((notification) =>
          NotificationsByGroup[type].includes(notification.eventType),
        )
        .sort(
          (a, b) =>
            NotificationsByGroup[type].indexOf(a.eventType) -
            NotificationsByGroup[type].indexOf(b.eventType),
        ),
    [type, notifications],
  );

  const isSelectedAll = useMemo(
    () => filteredNotifications.every((n) => n.channels.SLACK),
    [filteredNotifications],
  );

  const isPartialSelection = useMemo(() => {
    const unChecked =
      filteredNotifications.filter((n) => !n.channels.SLACK) ?? [];

    if (unChecked.length && unChecked.length < filteredNotifications.length) {
      return true;
    }

    return false;
  }, [filteredNotifications]);

  const onSelectAllNotifications = (e: CheckboxChangeEvent) => {
    return onNotificationChange(
      filteredNotifications.map((n) => ({
        ...n,
        channels: { ...n.channels, SLACK: e.target.checked },
      })),
    );
  };

  return (
    <Container>
      <Row align="top">
        <StyledCol flex="32px">{icon}</StyledCol>
        <Col flex="465px">
          <Text>{label}</Text>
        </Col>
        <Col>
          <Checkbox
            checked={filteredNotifications?.length > 0 ? isSelectedAll : false}
            indeterminate={isPartialSelection}
            onChange={onSelectAllNotifications}
          />
        </Col>
      </Row>
      <NotificationCollapse
        type={type}
        notifications={filteredNotifications}
        onNotificationChange={onNotificationChange}
        timeConfigurable={dateConfigurable}
      />
    </Container>
  );
};
